import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Amplify from "@aws-amplify/core";
import Auth from "@aws-amplify/auth";
import Analytics, { AWSKinesisProvider } from "@aws-amplify/analytics";
// import * as Sentry from "@sentry/browser";
// import "hammerjs";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import config from "./app/config";

Analytics.addPluggable(new AWSKinesisProvider());
Amplify.configure(config.amplify);
Analytics.configure({ AWSKinesis: config.amplify.AWSKinesis });

// Sentry.init({
//     dsn: config.Sentry.url,
//     environment: environment.name,
// });

if ((environment as any).production) {
    enableProdMode();
}
else {
    // (window as any).LOG_LEVEL = "DEBUG";
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => {
    // if (environment.production) {
    //     Sentry.captureException(err);
    // }
    console.error(err);
});
